import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genUnitValueFormatter } from "../tabellen/Tabellen";
import { genComponentFormatterLong } from "../model/util/Components";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";

class SpezifischeLeistungsaufnahmeTabelle extends React.Component {

	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		units: PropTypes.object.isRequired,
		intl: intlShape.isRequired,
		refresh: PropTypes.func.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		this.state = {};
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, units, intl } = this.props;

		return (
			<div>
				<Table.Provider
					className="printableAlmigItem"
					columns={[{
						property: "cindex",
						cell: { formatters: [ genComponentFormatterLong(compressors, intl) ] },
						header: {
							label: intl.formatMessage({ id: "Component" })
						},
						props: {
							style: {
								minWidth: 130
							}
						}
					}, {
						property: "gesamtspezifische_leistung_kWhm3",
						cell: { formatters: [ genUnitValueFormatter("energy_over_volume_over_minutes", units, intl, true) ]},
						header: {
							label: intl.formatMessage({ id: "Total specific power" })
						}
					}, {
						property: "spezifische_leistung_kWhm3",
						cell: { formatters: [ genUnitValueFormatter("energy_over_volume_over_minutes", units, intl, true) ]},
						header: {
							label: intl.formatMessage({ id: "Specific power" })
						}
					}]}>
					<Table.Header />
					<Table.Body rows={model.data} rowKey="cindex" />
				</Table.Provider>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(SpezifischeLeistungsaufnahmeTabelle);
